import React from 'react'
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RoomingDetails } from './RoomingDetails';
import { getRoomingListByFile } from '../../../store/slices/files/thunks';
import { setRoomingList } from '../../../store/slices/files/filesSlice';



export const Rooming = ({ file }) => {
  const dispatch = useDispatch();
  const { roomingList } = useSelector((state) => state.files);
  
  useEffect(() => {
    if (file.id) {
      dispatch(getRoomingListByFile(file.id))
    }

    return () => {
      dispatch(setRoomingList([]));
    }
  }, [file.id])

  return (
    <div>
      {
        roomingList.map((item, index) => (
          <RoomingDetails key={item.id} room={item} index={index} file={file} />
        ))
      }      
    </div>
  )
}
